import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from 'reactstrap';

import { routeGroups } from './Routes';
import { extractAccessToken } from '../helpers/decodeLocalStorage';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { ResponseList } from '../models/Response';
import { AdminDetail } from '../models/admin/MasterAdmin';
import { useAdminDetails } from '../queries';
import { useMasterMenu } from '../presentations/views/WorkflowMenuMasterConfig/queries';

export type MenuDropdownProps = {
    userId?: string;
    role?: string;
};

export function MenuDropdown(props: MenuDropdownProps) {
    const { userId, role } = props;

    const { data: masterMenu } = useMasterMenu();
    const menuIdNameMap = useMemo(
        () =>
            masterMenu
                ? new Map(masterMenu.map(menu => [menu.id, menu.menu_name]))
                : undefined,
        [masterMenu]
    );

    const { data: adminDetails } = useAdminDetails();
    const allowedMenuIdSet = useMemo(
        () =>
            adminDetails
                ? new Set(adminDetails.map(adminDetail => adminDetail.menu_id))
                : undefined,
        [adminDetails]
    );

    const displayRouteGroups = routeGroups
        .map(group => ({
            ...group,
            routeRows: group.routeRows
                .map(routes =>
                    routes.filter(
                        route =>
                            route.noAuth || allowedMenuIdSet?.has(route.menuId)
                    )
                )
                .filter(routes => routes.length > 0)
        }))
        .filter(group => group.routeRows.length > 0);

    return (
        <UncontrolledDropdown nav>
            <DropdownToggle
                nav
                caret
                className="text-dark position-relative mx-lg-0 mx-3"
            >
                Menu
            </DropdownToggle>
            <DropdownMenu
                style={{
                    top: '35px',
                    right: '1rem',
                    left: 'unset',
                    position: 'absolute'
                }}
            >
                {userId &&
                    displayRouteGroups.map((routeGroup, index) => (
                        <React.Fragment key={routeGroup.groupName}>
                            <DropdownItem header>
                                {routeGroup.groupName}
                            </DropdownItem>
                            <div className="divide-y">
                                {routeGroup.routeRows.map(
                                    (routeRow, routeRowIndex) => (
                                        <div key={routeRowIndex}>
                                            {routeRow.map(route => (
                                                <DropdownItem
                                                    key={route.pathname}
                                                >
                                                    <Link
                                                        to={route.pathname}
                                                    >
                                                        {/*{route.menuId}{' '}*/}
                                                        {menuIdNameMap?.get(
                                                            route.menuId
                                                        ) ?? route.menuName}
                                                    </Link>
                                                </DropdownItem>
                                            ))}
                                        </div>
                                    )
                                )}
                            </div>
                            {index < routeGroups.length - 1 && (
                                <DropdownItem
                                    divider
                                    className="my-0"
                                />
                            )}
                        </React.Fragment>
                    ))}

                {/*{userId && (*/}
                {/*    <>*/}
                {/*        <DropdownItem header>Workflow Config</DropdownItem>*/}
                {/*        {isAdmin && (*/}
                {/*            <DropdownItem>*/}
                {/*                <Link to="/workflowinboxadminsummary">*/}
                {/*                    Workflow Report*/}
                {/*                </Link>*/}
                {/*            </DropdownItem>*/}
                {/*        )}*/}
                {/*        {isSuperAdmin && (*/}
                {/*            <>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/MasterEmployee">*/}
                {/*                        Master Employee*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/roleemployee">*/}
                {/*                        Role Employee*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/rolemasteremployee">*/}
                {/*                        Role Master Employee*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/authoritygroup">*/}
                {/*                        Authority Group*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/conditionmaster">*/}
                {/*                        Parameter Master*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/callbackconfigmaster">*/}
                {/*                        Callback Config*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/callbacklogstart">*/}
                {/*                        Callback Stat*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/callbacklog">Callback Log</Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflow">Workflow Config</Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/createUserAdmin">*/}
                {/*                        Workflow Config Add Admin*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowinboxadminsummary">*/}
                {/*                        Workflow Summary*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowreport">*/}
                {/*                        Workflow Dashboard*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowinboxadmin">*/}
                {/*                        Workflow Inbox*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowlog">Workflow Log</Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowlogbuffer">*/}
                {/*                        Workflow Log Buffer*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/bufferstat">*/}
                {/*                        Workflow Buffer Stat*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflow-email-log">*/}
                {/*                        Workflow Email Log*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowconditionconfigurationreport">*/}
                {/*                        Workflow Condition Configuration Report*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflowassignmentroutingreport">*/}
                {/*                        Workflow Assignment Routing Report*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/assignmentroutingconfig">*/}
                {/*                        Workflow Assignment Routing Config*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/auth-history">*/}
                {/*                        Authentication History*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/export-employee-roles">*/}
                {/*                        Export Employee Roles*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/email-config">Email Config</Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflow-usage-rate">*/}
                {/*                        Workflow Usage Rate*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflow-performance">*/}
                {/*                        Workflow Performance Search*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*                <DropdownItem>*/}
                {/*                    <Link to="/workflow-type-master-config">*/}
                {/*                        Workflow Type Master Config*/}
                {/*                    </Link>*/}
                {/*                </DropdownItem>*/}
                {/*            </>*/}
                {/*        )}*/}
                {/*    </>*/}
                {/*)}*/}

                {/*<DropdownItem divider />*/}

                {/*<DropdownItem header>Workflow Working</DropdownItem>*/}
                {/*<DropdownItem>*/}
                {/*    <Link to="/workflowdashboard">Workflow Dashboard</Link>*/}
                {/*</DropdownItem>*/}
                {/*<DropdownItem>*/}
                {/*    <Link to="/workflowinbox">Workflow Inbox</Link>*/}
                {/*</DropdownItem>*/}
                {/*<DropdownItem>*/}
                {/*    <Link to="/createworkflow">Create Workflow</Link>*/}
                {/*</DropdownItem>*/}
                {/*<DropdownItem>*/}
                {/*    <Link to="/createworkflowwithwftype">*/}
                {/*        Create Workflow <br />*/}
                {/*        With Workflow Type*/}
                {/*    </Link>*/}
                {/*</DropdownItem>*/}
                {/*<DropdownItem>*/}
                {/*    <Link to="/simulateworkflow">Simulate Workflow</Link>*/}
                {/*</DropdownItem>*/}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
}
